import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DP1_0_FetchDataResponse } from '../interfaces/dp1.0-fetch-address.interface';
import { ApiService } from '../../common/api.service';
import { ROUTES } from '../../server-route';
@Injectable({
  providedIn: 'root'
})
export class Dp10FetchAddressService extends ApiService {

  public fetchAddressAttribute(paramsObj?: any): Observable<DP1_0_FetchDataResponse> {
    return this.get<DP1_0_FetchDataResponse>(ROUTES.DP_1_0_ADDRESS_ATTRIBUTE, {
      params: paramsObj,
    });
  }

  public fetchDP1_0_Data(paramsObj?: any): Observable<DP1_0_FetchDataResponse> {
    return this.get<DP1_0_FetchDataResponse>(ROUTES.DP_1_0_DETAILS, {
      params: paramsObj,
    });
  }
  public fetchStateDp10(params: { uiCountry?: string; state?: string; district?: string }): Observable<DP1_0_FetchDataResponse> {
    return this.get<DP1_0_FetchDataResponse>(ROUTES.DP_1_0_STATES, {
      params
    })
  }
  public sendDp10Data(memKey: any, bodyObj: any): Observable<DP1_0_FetchDataResponse> {
    return this.patch<DP1_0_FetchDataResponse>
      (this.replacePathInfo(ROUTES.DP_1_0_ASSIGN, {
        memKey: memKey
      }),
        {
          body: bodyObj,
        }
      )
  }
}